import React, { useState } from 'react'
import styled from 'styled-components'
import colors from '../utils/colors'
import { BsQuestionSquareFill } from 'react-icons/bs'
import { GrClose } from 'react-icons/gr'

const pointerStyles = {cursor: 'pointer'}

const ModalHeader = styled.span`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
`

const ModalContent = styled.span`
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 8px;
  max-width: 600px;
  width: 80%; 
`

const ModalText = styled.span`
  font-size: 2rem;
`

const Modal = styled.div`
  display: ${({ open }) => open ? 'flex' : 'none'}; 
  position: fixed; 
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto; 
  background-color: rgb(0,0,0); 
  background-color: rgba(0,0,0,0.4);
`

export default ({ title, children }) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <BsQuestionSquareFill onClick={() => setOpen(!open)} style={pointerStyles} />
      <Modal open={open} onClick={() => setOpen(!open)}>
        <ModalContent>
          <ModalHeader>
            <h3>{title}</h3>
            <GrClose onClick={() => setOpen(!open)} style={pointerStyles} />
          </ModalHeader>
          <ModalText>{children}</ModalText>
        </ModalContent>
      </Modal>
    </>
  )
}